<template>
    <transition name="fade">
        <div id="modal" :style="cssProps" class="modal-mask" v-show="show" transition="modal">
            <div class="modal-wrapper">
                <div class="modal-header">
                    <a v-if="!persistent" class="close-modal" @click="close()">
                        <i class="fas fa-times close-btn right"></i>
                    </a>
                    <slot name="header">
                        <p class="center">Atenção</p>
                    </slot>
                </div>
                <div class="modal-container">
                    <div class="modal-body" :id="idBody">
                        <slot name="body"> default body </slot>
                    </div>
                </div>
                <div class="modal-footer" v-if="showFooter">
                    <slot name="footer">
                        <button class="btn blue darken-4" @click="close()">OK</button>
                    </slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'MyComponent',
    props: {
        show: {
            type: Boolean,
            required: true,
            twoWay: true
        },
        showFooter: {
            type: Boolean,
            default: true
        },
        width: {
            type: String,
            default: '800px'
        },
        height: {
            type: String,
            default: '300px'
        },
        scrollable: {
            type: Boolean,
            default: true
        },
        footerPositionItens: {
            type: String,
            default: 'none'
        },
        headerColor: {
            type: String,
            default: '#fff'
        },
        persistent: {
            type: Boolean,
            default: false
        },
        paddingBody: {
            type: Boolean,
            default: true
        },
        idBody: {
            type: String,
            default: ''
        }
    },
    methods: {
        close() {
            this.$emit('close', false);
        },
        mobileView(value) {
            if (value == 'auto') return value;
            if (~value.indexOf('%')) return value; // retornar valor boleano
            let val = value.split('px')[0];
            let number;
            if (val > 0 && val < 800) number = val * 0.3;
            else if (val >= 800) number = val * 0.6;
            val = val - number;
            return `${val}px`;
        }
    },
    computed: {
        cssProps() {
            return {
                '--paddingBody': this.paddingBody ? '20px 30px' : '0px',
                '--height': `${this.height}`,
                '--mobHeight': `${this.mobileView(this.height)}`,
                // '--mobHeight': `${this.mobileView(this.height)}`,
                '--width': `${this.width}`,
                '--mobWidth': `${this.mobileView(this.width)}`,
                // '--mobWidth': `${this.mobileView(this.width)}`,
                '--scrollable': `${this.scrollable ? 'auto' : 'hiden'}`,
                '--footerPositionItens': `${this.computedFooterPositionItens}`,
                '--headerColor': `${this.headerColor}`
            };
        },
        computedFooterPositionItens() {
            if (this.footerPositionItens == 'none') {
                if (window.innerWidth >= 992) return 'right';
                else return 'center';
            } else {
                return this.footerPositionItens;
            }
        }
    }
    /*
	tentativa de fazer o modal fechar ao clicar fora dele :(
	mounted() {
		let modal = document.getElementById("modal");
		let vue = this;
		document.addEventListener("click", (evt) => {
			modal.addEventListener("click", function(e) {
				if (e.target != evt.target) {
					vue.close();
				}
			});
		});
	},
	*/
};
</script>
<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.close-modal {
    font-size: 20px;
    cursor: pointer;
    color: rgba(0, 0, 0);
}
.modal-container {
    width: var(--width);
    height: var(--height);
    margin: 0px auto;
    background-color: #fff;
    /* font-family: Helvetica, Arial, sans-serif; */
    overflow-y: var(--scrollable);
    max-height: var(--height);
}
.modal-container::-webkit-scrollbar {
    width: 10px; /* width of the entire scrollbar */
}
.modal-container::-webkit-scrollbar-track {
    background: #fff; /* color of the tracking area */
}

.modal-container::-webkit-scrollbar-thumb {
    background-color: #dbdbdb; /* color of the scroll thumb */
    border-radius: 10px; /* roundness of the scroll thumb */
    border: 3px solid #fff; /* creates padding around scroll thumb */
}
.modal-header {
    margin: 0px auto;
    width: var(--width);
    margin-top: 0;
    border-radius: 7px 7px 0px 0px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
    background-color: var(--headerColor) !important;
    padding-left: 10px;
    padding-top: 10px;
}

.modal-body {
    margin: 20px 0;
    padding: var(--paddingBody);
}
.modal-footer {
    margin: 0px auto;
    width: var(--width);
    border-top: 1px solid rgba(0, 0, 0, 0.3);
    background-color: #fff !important;
    padding: 10px;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    border-radius: 0px 0px 7px 7px;
    text-align: var(--footerPositionItens);
    -webkit-box-shadow: -1px -6px 10px -8px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: -1px -6px 10px -8px rgba(0, 0, 0, 0.75);
    box-shadow: -1px -6px 10px -8px rgba(0, 0, 0, 0.75);
}
.close-btn {
    margin-right: 10px;
    margin-bottom: 30px;
    color: #a5a5a5;
}
.modal-enter,
.modal-leave {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
@media screen and (max-width: 992px) {
    .modal-header {
        width: var(--mobWidth);
    }
    .modal-container {
        width: var(--mobWidth);
        max-height: var(--mobHeight);
    }
    .modal-footer {
        width: var(--mobWidth);
    }
}
</style>
